import React, { useState } from 'react';
import '../../assets/css/login.css';
import { jwtDecode } from 'jwt-decode';

const Login = () => {
  const [empCode, setEmpCode] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  let decoded = null;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://gannondunkerley.in/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ empCode, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        const token = localStorage.getItem('token');
        if (token) {
          try {
            decoded = jwtDecode(token);
          } catch (err) {
            console.error('Invalid token', err);
          }
        }

        window.location.href =
          decoded?.role === 'User' ? '/dashboard' : '/dashboard';
      } else {
        setMessage(data.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 style={{color:'black'}}>Gannon Dunkerley</h2>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label>EmpCode</label>
            <input
              type="text"
              value={empCode}
              onChange={(e) => setEmpCode(e.target.value)}
              required
              placeholder="Enter Emp Code"
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter Password"
            />
          </div>
          <button type="submit" className="login-btn">Login</button>
          <div className="reset-link">
            <a href="/reset"><b>Reset PIN via OTP</b></a>
          </div>
          {message && <p className="error-message">{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default Login;
